export default function MySQL_CURRENT_TIME() {
  return (
    <div>
      <h2>MySQL_CURRENT_TIME</h2>    </div>
  );
}